/** One inline notice row: "Rahul lost connection · waiting for them" (R6.4). */
import React from 'react';
import {View} from 'react-native';

import {Txt} from '../../../../ui';
import cardStyles from './cardStyles';

export default React.memo(function NoticeLineView({
  title,
  sub,
}: {
  title: string;
  sub?: string;
}) {
  return (
    <View style={cardStyles.rowCard}>
      <View style={cardStyles.text}>
        <Txt variant="label" numberOfLines={1}>
          {title}
        </Txt>
        {!!sub && (
          <Txt variant="captionTight" tone="muted" numberOfLines={1}>
            {sub}
          </Txt>
        )}
      </View>
    </View>
  );
});
